import Menu from "../components/Menu";
import ImageZoom from "../components/ImageZoom";
import { motion, AnimatePresence } from "framer-motion";
import tomek from "../images/DSC_8884.jpg";
import { Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";

export default function About() {
  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1.0, ease: "easeOut" },
    },
  };

  return (
    <>
      <Menu />

      <section className="section section-gray section-about" key="sectiongray">
        <AnimatePresence>
          <motion.div
            className="h1a"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={textVariants}
          >
            <Row key="row1">
              <Col sm={12} md={4}>
                KIM JESTEM I DLACZEGO MOJE ZDJĘCIA SPRZEDAJĄ SZYBCIEJ?
              </Col>
              <Col md={8}>
                <ImageZoom
                  src={tomek}
                  alt="tomek"
                  className="responsive-image"
                />
              </Col>
            </Row>
            <br />
            <Row key="row2">
              <Col sm={12} md={12}>
                <p className="h4a">
                  Nazywam się <b>Tomasz Jaskulski</b> i od ponad 20 lat pracuję
                  w branży filmowej oraz reklamowej. <br />
                  Jako kierownik produkcji współpracowałem przy realizacji
                  programów telewizyjnych, filmów i kampanii reklamowych. <br />
                  Dzięki temu wiem, że obraz musi nie tylko wyglądać — musi
                  opowiadać historię i budzić emocje.
                  <br /> Ta filmowa filozofia to podstawa mojej pracy jako
                  fotografa nieruchomości. Kiedy wchodzę do wnętrza, widzę w nim
                  scenę — światło, rytm, kompozycję. <br />
                  Dbam o każdy szczegół, tak jak na planie filmowym. <br />
                  Moje doświadczenie nauczyło mnie także jednej umiejętności:
                  <b>rozwiązywania problemów w każdych warunkach</b>. <br />
                  Niewygodne światło?
                  <br />
                  Za ciasne pomieszczenie?
                  <br />
                  Puste lokum deweloperskie?
                  <br />
                  Zawsze znajdę sposób, by wyglądało świetnie na zdjęciach.
                  <br />
                  Współpracuję z projektantami wnętrz, dekoratorami i
                  scenografami, dzięki czemu mogę oferować staging premium oraz
                  wirtualne wizualizacje na najwyższym poziomie. <br />
                  Fotografia nieruchomości to dla mnie połączenie techniki,
                  sztuki i opowiadania historii.
                  <br /> I to właśnie sprawia, że moje realizacje wyróżniają się
                  na tle konkurencji.
                </p>
              </Col>
            </Row>
          </motion.div>
        </AnimatePresence>
      </section>
    </>
  );
}
